import { render } from "./AddEditTemplateSlideOver.vue?vue&type=template&id=3f588e62"
import script from "./AddEditTemplateSlideOver.vue?vue&type=script&lang=ts"
export * from "./AddEditTemplateSlideOver.vue?vue&type=script&lang=ts"
script.render = render

export default script